
import Vue from "vue";
import { Menu } from "@ambii-com/core";

export default Vue.extend({
  props: {
    dialog: Boolean,
    width: String,
    hidePatientCountDialogClass: String
  },
  data(): {
    locale: string;
    selectedSubmenu: Menu;
    patientCount: number;
  } {
    return {
      locale: this.$i18n.locale,
      selectedSubmenu: null,
      patientCount: 1,
    };
  },
  watch: {
    dialog(val: boolean): void {
      if (val) {
        this.patientCount = 1;
      }
    },
    patientCount(val: number): void {
      if (val) {
        this.$emit("setPatientCount", this.patientCount);
      }
    },
  },
  methods: {
    resetAndCloseDialog(): void {
      this.patientCount = null;
      this.$emit("close");
      this.$emit("setPatientCount", this.patientCount);
    },
  },
});
